module.exports = __webpack_public_path__ + "img/background.615584cd.png";